import {
  Component,
  OnDestroy,
  ViewChild,
  OnInit,
  ViewContainerRef,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Member, TeamTexts } from "@/core/models";
import { Configuration } from "@/shared-module/models";

@Component({
  selector: "app-member-edit",
  templateUrl: "member-edit.component.html",
})
export class MemberEditComponent implements OnDestroy, OnInit {
  @ViewChild("template", { static: true }) template;
  @Output() submitted: EventEmitter<any> = new EventEmitter();
  @Output() cancelled: EventEmitter<void> = new EventEmitter();
  @Input() data: Member;
  @Input() texts: TeamTexts;
  @Input() errorMessage: string;
  preview: string;
  current: string;
  operation: string;
  tooLargeFile = false;
  memberForm: FormGroup;

  subs = new SubSink();
  cssColor: string;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private configurationService: ConfigurationService,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
      },
    );
  }

  onSubmit() {
    // if (this.memberForm.value)

    this.submitted.emit(this.memberForm.value);
  }

  cancel() {
    this.cancelled.emit();
  }

  get userName() {
    return this.memberForm.get("userName");
  }

  get password() {
    return this.memberForm.get("password");
  }

  get universityId() {
    return this.memberForm.get("universityId");
  }

  get email() {
    return this.memberForm.get("email");
  }

  get firstName() {
    return this.memberForm.get("firstName");
  }

  get lastName() {
    return this.memberForm.get("lastName");
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);

    this.memberForm = new FormGroup({
      userName: new FormControl("", [Validators.required]),
      password: new FormControl("", [Validators.required]),
      universityId: new FormControl(this.data.universityId, [
        Validators.required,
      ]),
      email: new FormControl(this.data.email, [
        Validators.required,
        Validators.email,
      ]),
      firstName: new FormControl(this.data.firstName, [Validators.required]),
      lastName: new FormControl(this.data.lastName, [Validators.required]),
      image: new FormControl(""),
    });

    if (this.data.subUserId) {
      this.operation = "update";
    } else {
      this.operation = "create";
    }

    if (this.data.photoId) {
      this.current = "/api/download/blob/" + this.data.photoId.toString();
    } else {
      this.current = "/img/Unknown-person.gif";
    }
  }

  // Image Preview
  uploadFile(event) {
    const file = (event.target as HTMLInputElement).files[0];

    if (file.size > 2200000) {
      this.tooLargeFile = true;
    } else {
      this.tooLargeFile = false;
      this.memberForm.patchValue({
        avatar: file,
      });
      this.memberForm.patchValue({
        image: file,
      });
      this.memberForm.get("image").updateValueAndValidity();

      // File Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.current = null;
        this.preview = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
